function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import List from "./list/list.class";
import { Constants as CONSTANTS } from "./list/commons/list.constants.class";
try {
  lm.sentry.configureScope(function (scope) {
    scope.setTag("kobi.composant", "productfamilypage");
  });
} catch (error) {
  console.warn("Sentry can't be initialize");
}
var ProductFamilyPage = /*#__PURE__*/function (_lm$Composant) {
  function ProductFamilyPage(id) {
    var _this;
    _classCallCheck(this, ProductFamilyPage);
    _this = _callSuper(this, ProductFamilyPage, [id]);
    var categoryId = _this.target.dataset.category;
    var version = _this.target.dataset.version;
    var locale = _this.target.dataset.locale;
    var displayContextPopin = _this.target.dataset.displaycontext;
    var configuration = {
      event: {
        target: _this.selectedFilters,
        key: "selectedFilters",
        dataKey: "filters"
      },
      url: "".concat(CONSTANTS.URL_API, "?category=").concat(categoryId, "&version=").concat(version, "&locale=").concat(locale)
    };
    new List(configuration);
    _initContextPopin(displayContextPopin);
    _this.initJsonld(_this.target);
    return _this;
  }
  _inherits(ProductFamilyPage, _lm$Composant);
  return _createClass(ProductFamilyPage, [{
    key: "initJsonld",
    value: function initJsonld(component) {
      var jsonLdData = component.querySelector("script.dataJsonLd");
      if (jsonLdData) {
        var jsonLdDataParsed = JSON.parse(jsonLdData.innerHTML);
        window.MetaTagEventBus.emit("jsonLdTrigger", {
          data: jsonLdDataParsed
        });
      }
    }
  }]);
}(lm.Composant);
function _initContextPopin(displayContextPopin) {
  if (displayContextPopin === "true") {
    window.dispatchEvent(new CustomEvent("openStoreContextLayer"));
  }
}
lm.DOMReady(function () {
  var familyComponent = document.querySelector("#component-productfamilypage");
  if (familyComponent) {
    new ProductFamilyPage("productfamilypage");
  }
});